"use client";
import { jsx } from "react/jsx-runtime";
import { cn } from "../utils.js";
import * as __rspack_external_react from "react";
import * as __rspack_external__radix_ui_react_checkbox_76182ac8 from "@radix-ui/react-checkbox";
const Checkbox = /*#__PURE__*/ __rspack_external_react.forwardRef(({ className, minus, ...props }, ref)=>/*#__PURE__*/ jsx(__rspack_external__radix_ui_react_checkbox_76182ac8.Root, {
        ref: ref,
        className: cn('tw-peer tw-h-[18px] tw-w-[18px] tw-shrink-0 tw-rounded-[3px] tw-border-[2px] tw-border-solid', 'tw-bg-neutral-light-100 dark:tw-bg-transparent', 'tw-border-neutral-light-500 dark:tw-border-neutral-dark-400', 'hover:tw-border-primary-light-500 hover:tw-bg-primary-light-100 dark:hover:tw-border-secondary-light-500', 'invalid:tw-border-alert-500 dark:invalid:tw-border-alert-300', 'disabled:tw-cursor-not-allowed disabled:tw-opacity-50', 'disabled:hover:tw-bg-neutral-light-100 dark:disabled:hover:tw-bg-transparent', 'disabled:tw-border-neutral-light-600 dark:disabled:tw-border-neutral-light-600', 'data-[state=checked]:tw-bg-primary-light-500 data-[state=checked]:tw-border-primary-light-500', 'dark:data-[state=checked]:tw-bg-secondary-light-500 dark:data-[state=checked]:tw-border-secondary-light-500', 'hover:data-[state=checked]:tw-bg-primary-light-400 hover:data-[state=checked]:tw-border-primary-light-400', 'dark:hover:data-[state=checked]:tw-bg-secondary-light-400 dark:hover:data-[state=checked]:tw-border-secondary-light-400', 'hover:disabled:data-[state=checked]:tw-bg-primary-light-500 hover:disabled:data-[state=checked]:tw-border-primary-light-500', 'dark:hover:disabled:data-[state=checked]:tw-bg-secondary-light-500 dark:hover:data-[state=checked]:tw-border-secondary-light-500', className),
        ...props,
        children: /*#__PURE__*/ jsx(__rspack_external__radix_ui_react_checkbox_76182ac8.Indicator, {
            className: cn('tw-flex tw-items-center tw-justify-center tw-text-current'),
            children: minus ? /*#__PURE__*/ jsx("svg", {
                width: "10",
                height: "10",
                viewBox: "0 0 10 10",
                fill: "none",
                children: /*#__PURE__*/ jsx("line", {
                    className: "tw-fill-neutral-light-100",
                    x1: "2",
                    y1: "5",
                    x2: "8",
                    y2: "5",
                    stroke: "white",
                    strokeWidth: "2",
                    strokeLinecap: "round"
                })
            }) : /*#__PURE__*/ jsx("svg", {
                width: "10",
                height: "8",
                viewBox: "0 0 10 8",
                fill: "none",
                children: /*#__PURE__*/ jsx("path", {
                    className: "tw-fill-neutral-light-100",
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M9.10003 0.200059C9.54185 0.53143 9.6314 1.15823 9.30002 1.60006L5.55873 6.58845C4.78419 7.62118 3.24871 7.66053 2.42229 6.66882L0.731804 4.64024C0.37824 4.21597 0.435564 3.5854 0.859841 3.23184C1.28412 2.87827 1.91468 2.9356 2.26825 3.35987L3.95873 5.38845L7.70003 0.400059C8.0314 -0.0417689 8.6582 -0.131312 9.10003 0.200059Z"
                })
            })
        })
    }));
Checkbox.displayName = __rspack_external__radix_ui_react_checkbox_76182ac8.Root.displayName;
export { Checkbox };
